
export const products = [
  {
    id: 1,
    name: "パフスリーブ半袖ラウンドネックトップス",
    price: "¥12,800",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/6d9e93896b69a140d9d7c04dc5b59042.png",
    description:
      "リラックスした着心地のオーバーサイズシャツ。上質なコットン素材を使用し、カジュアルからオフィススタイルまで幅広くお使いいただけます。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト", "ブラック", "ベージュ"],
    material: "コットン100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
    quickViewImage:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/eb5bdc64db357b6c07a14370547f3456.png",
  },
  {
    id: 2,
    name: "ウエスト切替ワンピース",
    price: "¥15,900",
    category: "Dresses",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/0d37a3eba2865c757652186ca715d377.jfif",
    description:
      "定番のデニムジャケット。着回し力抜群で、様々なスタイリングに合わせやすいアイテムです。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["インディゴブルー", "ライトブルー", "ブラック"],
    material: "コットン98%、エラスタン2%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 4,
    name: "オフショルダーニットトップス",
    price: "¥13,200",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/0468937c9ea036798c0248502dcf83d8.jfif",
    description:
      "美脚効果の高いストレートデニム。履き心地が良く、長時間着用しても疲れにくい設計です。",
    sizes: ["23", "24", "25", "26", "27", "28"],
    colors: ["インディゴブルー", "ライトブルー", "ブラック"],
    material: "コットン92%、ポリエステル6%、エラスタン2%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 7,
    name: "キャンバスミニバッグ",
    price: "¥14,200",
    category: "Bag",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/ae67b83ee47b80ce4f9e772dd038785d.png",
    description:
      "着心地の良いコットンワンピース。一枚でスタイリングが完成する万能アイテムです。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト", "ベージュ", "ネイビー"],
    material: "コットン100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 5,
    name: "リングレースワンピース",
    price: "¥16,800",
    category: "Dresses",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/f88d29b469a4c01bbc005b77073815e5.jfif",
    description:
      "温かみのあるケーブル編みのニットセーター。秋冬にぴったりの上質なウール混素材を使用。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["オフホワイト", "ベージュ", "グレー", "ネイビー"],
    material: "ウール70%、アクリル30%",
    care: "ドライクリーニング推奨",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 6,
    name: "裾フリルシャツ",
    price: "¥11,500",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/2d7a4e67b5f683784e60d0ec29e0b2c6.png",
    description:
      "上品なプリーツスカート。歩くたびに美しく揺れる シルエットが女性らしさを演出します。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ブラック", "ネイビー", "ベージュ", "グレー"],
    material: "ポリエステル100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 9,
    name: "ベルジーンズ",
    price: "¥12,500",
    category: "Bottoms",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/6006872294c284108fda11b0b6e12856.png",
    description:
      "柔らかな肌触りのカーディガン。レイヤードスタイルのアクセントとして最適です。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ベージュ", "グレー", "ピンク", "ネイビー"],
    material: "アクリル60%、ウール40%",
    care: "手洗い推奨",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 8,
    name: "カットアウトカーディガン",
    price: "¥7,200",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/d5cac322aa0e84d6d73216948732629c.png",
    description:
      "定番のボーダーTシャツ。コーディネートのベースアイテムとして活躍します。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト×ネイビー", "ホワイト×ブラック", "ベージュ×ブラウン"],
    material: "コットン100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 10,
    name: "オフショルサテントップス",
    price: "¥5,800",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/ff16a43563cdf81671889e6d820695d4.jfif",
    description:
      "シンプルなキャミソール。インナーとしても一枚でも着られる便利なアイテムです。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト", "ブラック", "ベージュ", "グレー"],
    material: "コットン95%、エラスタン5%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 11,
    name: "ストレートスラックス",
    price: "¥13,800",
    category: "Bottoms",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/755fd0224504e9c8f81433d4e285b2a8.png",
    description:
      "快適な着心地のフーディー。リラックスした時間にぴったりのアイテムです。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["グレー", "ネイビー", "ベージュ", "ピンク"],
    material: "コットン80%、ポリエステル20%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 12,
    name: "半袖ポロニット",
    price: "¥10,202",
    category: "Bottoms",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/2986065e4614e3ef2abdd2a1927b8c5d.png",
    description:
      "エレガントなマキシスカート。歩くたびに美しく揺れるシルエットが魅力的です。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ブラック", "ネイビー", "ベージュ", "オリーブ"],
    material: "レーヨン100%",
    care: "洗濯機洗い可能（ネット使用）",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 13,
    name: "ギャザーオフショルトップス",
    price: "¥8,800",
    category: "Tops",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/fbc55f58dcc1d13b69b00b1343ad089e.png",
    description:
      "上品な印象のポロシャツ。カジュアルからビジネスカジュアルまで対応できます。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト", "ネイビー", "ピンク", "グレー"],
    material: "コットン100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 14,
    name: "袖レースサマーニット",
    price: "¥15,500",
    category: "Dresses",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/e85d9a5aeb39061033331a58fc1edc5f.png",
    description:
      "クラシックなシャツワンピース。一枚でコーディネートが決まる優秀アイテムです。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["ホワイト", "ストライプ", "ネイビー"],
    material: "コットン100%",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  },
  {
    id: 15,
    name: "ピンスシャツショートパンツセット",
    price: "¥18,900",
    category: "Outerwear",
    image:
      "https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/69dc6a59c1487adfe9f3047ad983d153.png",
    description:
      "トレンド感のあるブルゾン。軽やかな着心地で春秋のアウターとして最適です。",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["カーキ", "ネイビー", "ブラック"],
    material: "ナイロン100%（裏地：ポリエステル100%）",
    care: "洗濯機洗い可能",
    isNew: false,
    isRecommended: false,
  }
];
